var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlayStoreSmallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6123 1.06952C2.2523 0.829516 1.81234 0.759555 1.40234 0.859555L8.62231 8.07953L10.9623 5.73944L2.62231 1.06952H2.6123Z",
    fill: "#0F0F0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.50354 1.44946C0.30354 1.71946 0.183594 2.0494 0.183594 2.3894V15.2395C0.183594 15.5895 0.30354 15.9194 0.50354 16.1794L7.87354 8.80957L0.50354 1.43945V1.44946Z",
    fill: "#0F0F0F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0133 7.44946L11.9133 6.26953L9.36328 8.81958L11.9133 11.3696L14.0133 10.1895C14.5133 9.90945 14.8134 9.38958 14.8134 8.81958C14.8134 8.24958 14.5133 7.72946 14.0133 7.44946Z",
    fill: "#0F0F0F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62231 9.55957L1.40234 16.7795C1.52234 16.8095 1.64233 16.8196 1.76233 16.8196C2.06233 16.8196 2.3523 16.7396 2.6123 16.5696L10.9523 11.8994L8.6123 9.55957H8.62231Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayStoreSmallIcon);
export default __webpack_public_path__ + "static/media/googlePlayStoreSmallIcon.4589ef45173c534961beba1370c09c29.svg";
export { ForwardRef as ReactComponent };